var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{key:"loader"},[_c('section',{class:{
      'section section-project-no-border section-100 pa-0':
        _vm.$vuetify.breakpoint.mdAndUp,
      'section section-project-no-border section-90 pa-0':
        _vm.$vuetify.breakpoint.smAndDown,
    }},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('div',{staticClass:"lds-roller"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }